<template>
  <div class="custom-dropdown">
    <button type="button" class="cd-toggle" @click="open = !open">
      {{ selectedLabel || placeholder }}
      <span class="caret"></span>
    </button>

    <ul v-show="open" class="cd-list">
      <li v-for="opt in options" :key="opt.short"
          :class="{selected: opt.short === value}"
          @click="select(opt)">
        {{ opt.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CustomDropdown',
  props: {
    value: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: 'Select' }
  },
  data() {
    return { open: false };
  },
  computed: {
    selectedLabel() {
      const found = this.options.find(o => o.short === this.value);
      return found ? found.name : '';
    }
  },
  methods: {
    select(opt) {
      this.$emit('input', opt.short);
      this.open = false;
    }
  }
};
</script>

<style>
.cd-list { position:absolute; z-index:50; list-style:none; margin:0; padding:0; border:1px solid #ccc; background:#fff; }
.cd-list li { padding:3px 5px; cursor:pointer; }
.cd-list li.selected { background:#e6f2ff; font-weight:600; }
</style>



// WEBPACK FOOTER //
// src/components/CustomDropdown.vue